"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var TableContext = react_1.createContext({
    currentEditing: undefined,
    isEditing: function (record) { return false; },
    setEditing: function (record) { },
});
exports.default = TableContext;
